"use client";

import { GlobalErrorComponent } from "@/components/common";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
export default function GlobalError({
  error
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return <GlobalErrorComponent data-sentry-element="GlobalErrorComponent" data-sentry-component="GlobalError" data-sentry-source-file="global-error.jsx" />;
}